import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
@Component({
  templateUrl: "./success.component.html",
  styleUrls: ["success.css"]
})
export class SuccessComponent {
  environment: any;
  serviceName: string;
  amount: any;
  date: string;


  constructor(private route:ActivatedRoute) {
    this.environment = environment
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.serviceName = params['service'];
      this.amount = Number(params['amount']);
      this.date = params['date'];
    })
  }
}
